import type { MaskPreset } from "../types";
import { BaseMaskAdapter } from "./base-adapter";

const DOCUMENT_MASKS: Record<Extract<MaskPreset, "cnpj" | "cpf">, string> = {
  cnpj: "##.###.###/####-99",
  cpf: "999.999.999-99",
};

export class DocumentPresetAdapter extends BaseMaskAdapter {
  private readonly preset: "cnpj" | "cpf";

  constructor(preset: "cnpj" | "cpf") {
    const maskPattern = DOCUMENT_MASKS[preset];
    super(maskPattern);
    this.preset = preset;
  }

  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }

    return this.applyGenericMask(String(value));
  }

  parseFromInput(inputValue: string): { value: string; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: "", formatted: "" };
    }

    const formatted = this.applyGenericMask(inputValue);
    const cleanValue = this.cleanValue(inputValue);

    return {
      value: cleanValue,
      formatted,
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }

    return this.applyGenericMask(String(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    // CPF: digits only
    // CNPJ: alphanumeric (allows letters in some cases)
    if (this.preset === "cpf") {
      return /^\d$/.test(key);
    }
    return /^[a-zA-Z0-9]$/.test(key);
  }
}
